<nb-card class="srtPoint">
  <nb-card-header class="header">
    <div class="headerTop">
      <div class="kicker">SRT-точка</div>
      <button class="iconBtn" (click)="close()" aria-label="Закрити"><nb-icon icon="close-outline" pack="eva"></nb-icon></button>
    </div>
    <div class="titleRow">
      <input nbInput fieldSize="medium" fullWidth maxlength="120" [(ngModel)]="titleValue" (keyup.enter)="saveTitle()" (blur)="saveTitle()" aria-label="Назва" />
    </div>
    <div class="status" *ngIf="point">
      <span class="signalBadge" [class.on]="point.hasSignal">{{ point.hasSignal ? 'Сигнал є' : 'Немає сигналу' }}</span>
      <span class="metric"><span class="metricLabel">Вхідний бітрейт</span>{{ point.inputMbps !== null ? point.inputMbps + ' Мбіт/с' : '—' }}</span>
      <span class="metric"><span class="metricLabel">Підключено виходів</span>{{ point.readers }}</span>
    </div>
  </nb-card-header>

  <nb-card-body class="body" *ngIf="point">
    <section class="section">
      <div class="sectionHead">Підключення</div>
      <div class="field">
        <div class="fieldLabel">Сервер</div>
        <div class="fieldValue mono">{{ serverUrl }}</div>
        <div class="actions"><button class="iconBtn" ngxClipboard [cbContent]="serverUrl" (cbOnSuccess)="copied()" aria-label="Копіювати"><nb-icon icon="copy-outline" pack="eva"></nb-icon></button></div>
      </div>
      <div class="field">
        <div class="fieldLabel">Режим</div>
        <div class="fieldValue">Caller</div>
        <div class="actions"></div>
      </div>
      <div class="field">
        <div class="fieldLabel">Затримка</div>
        <div class="fieldValue">
          <nb-select size="small" [selected]="point.latencyMs" (selectedChange)="setLatency($event)" [disabled]="latencySaving">
            <nb-option *ngFor="let ms of latencies" [value]="ms">{{ ms }} мс</nb-option>
          </nb-select>
        </div>
        <div class="actions"></div>
      </div>
      <div class="hint">Задається в програмі-кодері та програмі-приймачі як параметр SRT latency. Рекомендовано не менше трьох значень RTT між вами та сервером; для міжнародних каналів — від 1000 мс.</div>
    </section>

    <section class="section">
      <div class="sectionHead">
        <span>Вхід · публікація</span>
        <span class="rotate" *ngIf="confirmRotate !== 'publish'"><button class="textBtn" [disabled]="!!rotating" (click)="confirmRotate = 'publish'">Згенерувати новий ключ</button></span>
        <span class="rotate" *ngIf="confirmRotate === 'publish'">
          <span class="confirmText">{{ 'publish' === 'publish' ? 'Поточне джерело буде відключено' : 'Поточні отримувачі будуть відключені' }}</span>
          <button class="textBtn danger" [disabled]="!!rotating" (click)="rotate('publish')">Підтвердити</button>
          <button class="textBtn" (click)="confirmRotate = ''">Скасувати</button>
        </span>
      </div>
      <div class="field">
        <div class="fieldLabel">Stream ID</div>
        <div class="fieldValue mono" [class.masked]="!show.publish">{{ show.publish ? publishStreamId : masked }}</div>
        <div class="actions">
          <button class="iconBtn" (click)="show.publish = !show.publish" aria-label="Показати"><nb-icon [icon]="show.publish ? 'eye-off-outline' : 'eye-outline'" pack="eva"></nb-icon></button>
          <button class="iconBtn" ngxClipboard [cbContent]="publishStreamId" (cbOnSuccess)="copied()" aria-label="Копіювати"><nb-icon icon="copy-outline" pack="eva"></nb-icon></button>
        </div>
      </div>
      <div class="field">
        <div class="fieldLabel">URL</div>
        <div class="fieldValue mono" [class.masked]="!show.publish">{{ show.publish ? point.publishUrl : maskedUrl('publish') }}</div>
        <div class="actions">
          <button class="iconBtn" (click)="show.publish = !show.publish" aria-label="Показати"><nb-icon [icon]="show.publish ? 'eye-off-outline' : 'eye-outline'" pack="eva"></nb-icon></button>
          <button class="iconBtn" ngxClipboard [cbContent]="point.publishUrl" (cbOnSuccess)="copied()" aria-label="Копіювати"><nb-icon icon="copy-outline" pack="eva"></nb-icon></button>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="sectionHead">
        <span>Вихід · отримання</span>
        <span class="rotate" *ngIf="confirmRotate !== 'read'"><button class="textBtn" [disabled]="!!rotating" (click)="confirmRotate = 'read'">Згенерувати новий ключ</button></span>
        <span class="rotate" *ngIf="confirmRotate === 'read'">
          <span class="confirmText">{{ 'read' === 'publish' ? 'Поточне джерело буде відключено' : 'Поточні отримувачі будуть відключені' }}</span>
          <button class="textBtn danger" [disabled]="!!rotating" (click)="rotate('read')">Підтвердити</button>
          <button class="textBtn" (click)="confirmRotate = ''">Скасувати</button>
        </span>
      </div>
      <div class="field">
        <div class="fieldLabel">Stream ID</div>
        <div class="fieldValue mono" [class.masked]="!show.read">{{ show.read ? readStreamId : masked }}</div>
        <div class="actions">
          <button class="iconBtn" (click)="show.read = !show.read" aria-label="Показати"><nb-icon [icon]="show.read ? 'eye-off-outline' : 'eye-outline'" pack="eva"></nb-icon></button>
          <button class="iconBtn" ngxClipboard [cbContent]="readStreamId" (cbOnSuccess)="copied()" aria-label="Копіювати"><nb-icon icon="copy-outline" pack="eva"></nb-icon></button>
        </div>
      </div>
      <div class="field">
        <div class="fieldLabel">URL</div>
        <div class="fieldValue mono" [class.masked]="!show.read">{{ show.read ? point.readUrl : maskedUrl('read') }}</div>
        <div class="actions">
          <button class="iconBtn" (click)="show.read = !show.read" aria-label="Показати"><nb-icon [icon]="show.read ? 'eye-off-outline' : 'eye-outline'" pack="eva"></nb-icon></button>
          <button class="iconBtn" ngxClipboard [cbContent]="point.readUrl" (cbOnSuccess)="copied()" aria-label="Копіювати"><nb-icon icon="copy-outline" pack="eva"></nb-icon></button>
        </div>
      </div>
      <div class="hint">Дані виходу дозволяють лише отримувати сигнал — їх можна передавати партнерам. Коли вхідний сигнал зникає, виходи відключаються; у приймачі варто увімкнути автоматичне перепідключення.</div>
    </section>

    <section class="section last" *ngIf="status">
      <div class="quotaHead">
        <span>Вихідні потоки акаунта</span>
        <span class="quotaValue">{{ status.quota.used }} / {{ status.quota.limit }}</span>
      </div>
      <nb-progress-bar size="tiny" [value]="quotaPercent" [status]="quotaPercent >= 100 ? 'warning' : 'primary'"></nb-progress-bar>
      <div class="hint">Ліміт тарифу спільний для ретрансляцій у соцмережі та виходів усіх SRT-точок.</div>
      <div class="event" *ngIf="lastEventText"><span class="eventTime">{{ lastEventTime }}</span>{{ lastEventText }}</div>
    </section>
  </nb-card-body>
</nb-card>
